import { BaseService } from '../../../infra/base.service'
import type { Card } from './card'
import type { MoveCardDto } from './cards-move.dto'
import type { CardsRepository } from './cards.repository'

export class CardsService extends BaseService<Card> {
    constructor(private rep: CardsRepository) {
        super(rep)
    }

    async move(cardId: string, moveCardDto: MoveCardDto) {
        this.rep.move(cardId, moveCardDto)
    }
}
